import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";

const Edit = ({ show, onClose }) => {
   const [selectedOption, setSelectedOption] = useState(null);
  

  const option_area = [
    { value: "0", label: "KK Nagar" },
    { value: "1", label: "Vandiyur" },
    { value: "2", label: "80 Feet Road" },
    { value: "3", label: "Goripalayam" },
];

  const [isFocused] = useState(false);

  useEffect(() => {
    if (isFocused) {
      console.log('The input is focused!');
    }
  }, [isFocused]);
  const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);
  // Add new IP configuration
  const handleAddConfig = () => {
    setRawMatrial([...rawMatrial, { id: Date.now() }]);
  };

  // Delete an IP configuration
  const handleDeleteConfig = (id) => {
    setRawMatrial(rawMatrial.filter(config => config.id !== id));
  };

  return (
    <Modal show={show} size="md">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Subscriber</h3>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Subscriber<span className="required">*</span></label>
              <input type="text" className="form-control" placeholder="Enter Subscribers Name" defaultValue={'Keshvi Shri'} />
            </div>
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Mobile No<span className="required">*</span></label>
              <input type="text" className="form-control" placeholder="Enter Mobile No" defaultValue={8521479630} />
            </div>
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Email ID</label>
              <input type="text" className="form-control" placeholder="Enter Email ID" defaultValue={'keshvishri@gmail.com'} />
            </div>
            {/* <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">Address<span className="required">*</span></label>
              <textarea rows={8} className="form-control" placeholder="Enter Address" defaultValue={"43F, Murugan Kovil Street, Vandiyur, Madurai - 625015"} />
            </div> */}
            <div className="col-lg-6 mb-3">
              <label className="text-black font-w500 fs-7">Area <span className="required">*</span></label>
              <Select
                defaultValue={selectedOption}
                onChange={setSelectedOption}
                options={option_area}
                placeholder="Select Area"
              />
            </div>
            <div className="col-lg-12 mb-3">
              <div className="mb-0">
                {rawMatrial.map(config => (
                  <div key={config.id} data-repeater-item>
                    <div className="row">
                      <div className='col-lg-11'>
                        <label className="text-black font-w500 fs-7">Address <span className="required">*</span></label>
                        <textarea rows={8} className="form-control" placeholder="Enter Address" defaultValue={"43F, Murugan Kovil Street, Vandiyur, Madurai - 625015"} />
                      </div>

                      <div className="col-lg-1 mb-1 px-1 py-1">
                        {rawMatrial.length > 1 && (
                          <button
                            className="btn btn-danger mt-4 px-2 py-2"
                            onClick={() => handleDeleteConfig(config.id)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Delete"
                          >
                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mb-1 mt-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleAddConfig}
                >
                  <span><i className="fa-solid fa-plus fs-6"></i></span>
                  <span className='ms-2 fs-7'>Add Address</span>
                </button>
              </div>
            </div>
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea className="form-control h-auto" placeholder="Enter Description" defaultValue={"Subscriber shows interest in upgrades or new offers and has a history of positive feedback or referrals. They are likely to become long-term Subscriberss"} />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
            <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
            <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Subscriber</Link>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Edit;
